var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0602 11.8216L20.9002 11.6016C20.6202 11.2616 20.2902 10.9916 19.9102 10.7916C19.4002 10.5016 18.8202 10.3516 18.2202 10.3516H5.7702C5.1702 10.3516 4.6002 10.5016 4.0802 10.7916C3.6902 11.0016 3.3402 11.2916 3.0502 11.6516C2.4802 12.3816 2.2102 13.2816 2.3002 14.1816L2.6702 18.8516C2.8002 20.2616 2.9702 22.0016 6.1402 22.0016H17.8602C21.0302 22.0016 21.1902 20.2616 21.3302 18.8416L21.7002 14.1916C21.7902 13.3516 21.5702 12.5116 21.0602 11.8216ZM14.3902 17.3416H9.6002C9.2102 17.3416 8.9002 17.0216 8.9002 16.6416C8.9002 16.2616 9.2102 15.9416 9.6002 15.9416H14.3902C14.7802 15.9416 15.0902 16.2616 15.0902 16.6416C15.0902 17.0316 14.7802 17.3416 14.3902 17.3416Z",
    fill: "#313133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.561 8.59643C20.5986 8.97928 20.1833 9.23561 19.8185 9.11348C19.3137 8.94449 18.7824 8.86 18.2299 8.86H5.76988C5.21304 8.86 4.66478 8.95012 4.15322 9.12194C3.79283 9.24298 3.37988 8.99507 3.37988 8.61489V6.66C3.37988 3.09 4.46988 2 8.03988 2H9.21988C10.6499 2 11.0999 2.46 11.6799 3.21L12.8799 4.81C13.1299 5.15 13.1399 5.17 13.5799 5.17H15.9599C19.0856 5.17 20.3069 6.00724 20.561 8.59643Z",
    fill: "#313133"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.11eda3896e7b55c18a8f5a6f93f25bd8.svg";
export { ForwardRef as ReactComponent };